import React from 'react';
import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';

export const CouponsSection = ({ coupons, setCoupons, generateId }) => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardContent className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-medium">Coupon Codes</h3>
            <p className="text-sm text-slate-500">Manage discount codes for this prop firm</p>
          </div>
          <Button
            onClick={() => setCoupons([...coupons, { id: generateId(), discount: '', code: '' }])}
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Coupon
          </Button>
        </div>

        {coupons.length === 0 && (
          <div className="text-center py-8 text-slate-500">
            No coupons added yet. Click &quot;Add Coupon&quot; to create one.
          </div>
        )}

        {coupons.map((coupon, index) => (
          <Card key={coupon.id} className="border-slate-200">
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-4">
                <span className="font-medium">Coupon {index + 1}</span>
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-red-600"
                  onClick={() => setCoupons(coupons.filter(c => c.id !== coupon.id))}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Discount</Label>
                  <Input
                    placeholder="e.g., 15% OFF, $50 OFF"
                    value={coupon.discount}
                    onChange={(e) => {
                      const newCoupons = [...coupons];
                      newCoupons[index].discount = e.target.value;
                      setCoupons(newCoupons);
                    }}
                    className="mt-2"
                  />
                </div>
                <div>
                  <Label>Code</Label>
                  <Input
                    placeholder="e.g., SAVE15, WELCOME50"
                    value={coupon.code}
                    onChange={(e) => {
                      const newCoupons = [...coupons];
                      newCoupons[index].code = e.target.value.toUpperCase();
                      setCoupons(newCoupons);
                    }}
                    className="mt-2"
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  );
};